module.exports = __webpack_public_path__ + "img/MGH-Toyosu-2-2440x1172.72beab7d.jpg";